import { Component } from '@angular/core';
import { QueryParams } from '../../user/models/user.model';
import { PDF, CSV, XLS } from './downloader';
import { UserAsssetService } from '../../user-asset/services/user-assset.service';

@Component({
  selector: 'app-all-user-asset',
  templateUrl: './all-user-asset.component.html',
  styleUrls: ['./all-user-asset.component.scss']
})
export class AllUserAssetComponent {

    currentPage = 0;
  pageSize = 10;
  queryParams: QueryParams = {
    fillter: '{}',
    sortObj: '{}',
    page: this.currentPage + 1,
    limit: this.pageSize,
  };

    constructor(
      private service: UserAsssetService,
  
    ) { }
  
    ngOnInit(): void {

    }

  
    handleDoc(value: any): void {
      let docType = {
        export: value,
      }
      this.service.getUserAssetApiListDoc().subscribe(
        (response: any) => {
          if (value === "pdf") {
            const pdfData = JSON.parse(response)
            PDF(pdfData.result.pdfData, pdfData.result.user);
          } else if (value === "csv") {
            CSV(response);
          } else if (value === 'xls') {
            const pdfData = JSON.parse(response)
            XLS(pdfData)
          }
        }
      )
    }
    
}
